import React from "react";
import { css } from "aphrodite/no-important";
import { styles } from "src/components/AuthorCombinedStyles";
import { CombinedTrendChart } from "./charts/CombinedTrendChart";
import { CombinedInfo } from "./CombinedInfo";

interface IAuthorCombinedProps {
    author_id: string;
}

class AuthorCombinedState {
    public readonly startYear: number = 0;
    public readonly endYear: number = 0;
    constructor() {
        const date = new Date();
        this.startYear = date.getFullYear() - 5;
        this.endYear = date.getFullYear();
    }
}

export class AuthorCombined extends React.Component<IAuthorCombinedProps, AuthorCombinedState> {
    
    constructor(props: IAuthorCombinedProps){
        super(props);
        this.state = new AuthorCombinedState();
    }

    public render() {
        return (
            <div id="content" className={css(styles.content)}  >
                <div id="trend_container" className={css(styles.trendContainer)}   >
                    <CombinedTrendChart author_id={this.props.author_id} startYear={2014} endYear={2019} onRangeChanged={this.onRangeChanged}/>
                    <CombinedInfo author_id={this.props.author_id} startYear={this.state.startYear} endYear={this.state.endYear} />
                </div>
            </div>
        );
    }

    public onRangeChanged = (startYear: number, endYear: number) => {
        this.setState({...this.state,startYear: startYear, endYear: endYear})
    }

}


// WEBPACK FOOTER //
// ./src/components/AuthorCombined.tsx